module.exports = __webpack_public_path__ + "static/img/logo_remote.00ae4eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_remote.png
// module id = JIGi
// module chunks = 1